import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getJiraSummary } from '@api';

export const getJiraSummarySlice = createGetAsyncSlice({
	name: 'jiraSummary',
	receive: true,
	request: false,
	requestHandler: getJiraSummary,
	retainDataOnRequest: true
});
